import { EffectFunction } from './index.js';
import { Adslot } from '../modules/adslot-controller/adslot.js';

const sdgUnfilled: string = 'sdgUnfilled';

/**
 * Will mark the slot as "unfilled" with an CSS class, so other CSS rules can react to it.
 * Example: Hide AdLabel when slot is empty.
 * @constructor
 */
export const MARK_HULL_AS_UNFILLED: EffectFunction = ({ slotHull }: Adslot) => {
    slotHull.classList.add(sdgUnfilled);
    return () => {
        slotHull?.classList.remove(sdgUnfilled);
    };
};
